import {
  clanMembersErrorSelector,
  clanMembersIsFetchingSelector,
  clanMembersSelector,
  clanMembersSortSelector,
  disabledIdsSelector,
  selectedMemberIdsSelector,
} from '~/store/selectors/membersSelectors';
import { statisticsSelector } from '~/store/selectors/ratingsSelectors';
import { createAppSelector } from '~/store/utils/createSelector';

export const clanMembersPageSelector = createAppSelector(
  [
    clanMembersIsFetchingSelector,
    selectedMemberIdsSelector,
    clanMembersSelector,
    clanMembersErrorSelector,
    clanMembersSortSelector,
    disabledIdsSelector,
    statisticsSelector,
  ],
  (isFetchingMembers, selectedMemberIds, members, membersError, sort, disabledIds, statistics) => {
    return {
      isFetchingMembers,
      selectedMemberIds,
      members,
      membersError,
      sort,
      disabledIds,
      statistics,
    };
  },
);
